import { StylesConfig } from 'react-select';
import { FilterOption } from './UseGroupDynamicTypeaheadSelect/Types';

export const stylesConfig: StylesConfig<FilterOption> = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    fontSize: '0.875rem',
    fontWeight: '500',
    height: '38px',
    borderColor: state.isFocused ? '#187A90' : '#BEC0C5',
    cursor: state.isDisabled ? 'not-allowed' : 'default',
    '&:hover': {
      color: '#187A90',
    },
  }),
  option: (styles, { isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? '#187a904d' : 'white',
      padding: '12px 20px',
      zIndex: 100,
    };
  },
  menu: (styles) => ({
    ...styles,
    zIndex: 100,
    maxHeight: 'calc(100vh - 350px)',
    '@media (min-width: 401px) and (max-width: 768px)': {
      maxHeight: 'calc(100vh - 650px)',
    },
    '@media (max-width: 400px)': {
      maxHeight: 'calc(100vh - 600px)',
    },
    overflow: 'hidden',
  }),
  menuPortal: (base) => ({ ...base, zIndex: 100 }),
  input: (base) => ({
    ...base,
    'input:focus': {
      boxShadow: 'none',
    },
  }),
};
